import { fade } from '@material-ui/core/styles/colorManipulator';

export const styles = theme => ({ 
    note: {
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color : 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        padding: '32px 56px'
    },
    chip: {
        marginBottom: '10px',
        marginRight: '10px',
    },  
    footer:{
        justifyContent: 'space-between',
        display: 'flex',
        padding: '0px  !important',
    },
    list:{
        maxHeight: "12rem"
    },
    footerList: {
        justifyContent: 'space-between',
        display: 'flex',
        bottom: '10%',
    },
    buttonAddPhone: {
        marginLeft: '1rem'
    },
    tabsRoot:{
        backgroundColor: '#fff'
    },
    title: {
        fontWeight: 500,
        marginTop: '3.268%',
        marginBottom: '3.268%',
        fontSize: '24px',
        textAlign: 'center',
    },
    marginCloseButton: {
        marginTop: 4,
        minWidth: 45
    },
    rootDialogContent: {
        padding: '0% 3.8542%',
    },
    rootDialogActions: {
        margin: 0,
        position: 'absolute',
        top: '0%',
        right: '0%'
    },  
    titleFrame: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    containerButton:{
        display: 'flex',
        justifyContent: 'flex-end',
    },
    containerPhoneInput:{
        display: 'flex',
        flex: 1
    },
    phoneInput: {
        padding: '12px'
    },
})